import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Box, Typography } from '@material-ui/core';
import { formatDate, shortTimeFormat } from 'utils/date';
import useStyles from './Message.styles';

const Message = props => {
  const classes = useStyles();
  const { message, isMe } = props;
  const position = isMe ? 'right' : 'left';
  const theme = isMe ? 'themePrimary' : 'themeDefault';
  const time = formatDate(message.postedAt, shortTimeFormat);

  return (
    <Box
      mb={2}
      className={cn(classes.root, {
        [classes[position]]: true,
      })}
    >
      <Box
        py={1}
        px={2}
        className={cn(classes.body, {
          [classes[theme]]: true,
        })}
      >
        {!isMe && (
          <Typography variant="body2" className={classes.sender}>
            {message.sender}
          </Typography>
        )}
        <Box mr={1}>
          <Typography variant="body1">{message.text}</Typography>
        </Box>
        <div className={classes.time}>{time}</div>
      </Box>
    </Box>
  );
};

Message.propTypes = {
  message: Type.shape({
    id: Type.string.isRequired,
    uid: Type.string.isRequired,
    postedAt: Type.string.isRequired,
    sender: Type.string.isRequired,
    text: Type.string.isRequired,
  }).isRequired,
  isMe: Type.bool.isRequired,
};

export default Message;
